import LabDisplay from './lab-display-container';

export default LabDisplay;
